import { measureTypes } from ".";
import { colSettings } from "../../common/components/table/agGrid/colSettings";
import { useMarketDynamicsStore } from "../../store/marketDynamics/store";
import { soldAvgVsMedianPrice } from "./listingViews/soldAvgVsMedianPrice";
import { supplyAmpDemandNumUnits } from "./listingViews/supplyAmpDemandNumUnits";
import { marketDynamicsColumns as mdCols } from "./marketDynamicsColumns";

export const officeBreakdownColsByListing = {
    [soldAvgVsMedianPrice.tableSettings.id]: () =>[
        { col: mdCols.timePeriodStart, colDef: colSettings.quarterNumYearFormat },
        { col: mdCols.soldUnits, colDef: colSettings.numberSmInteger, measureType: measureTypes.units },
        { col: mdCols.soldMedianVolume, colDef: colSettings.numberSmVolume },
        { col: mdCols.soldAvgVolume, colDef: colSettings.numberSmVolume },
        { col: mdCols.soldChangeVolume, colDef: colSettings.numberSmVolume },
        { col: mdCols.soldGrowthVolumePct, colDef: colSettings.numberSmPercentage },
        { col: mdCols.soldAvgDom, colDef: colSettings.numberSmInteger }
    ],
    [supplyAmpDemandNumUnits.tableSettings.id]: () => {
        const selectedStatusOptionsIds = useMarketDynamicsStore.getState()?.checkedStatusOptions.map(item => item.id);
        const cols = supplyAmpDemandNumUnits.tableSettings.tables;
        const revisedCols = [
            { col: mdCols.timePeriodStart },
            ...cols.filter(col => selectedStatusOptionsIds.includes(col?.statusId))
        ];
        return revisedCols;
    },
};

export const commonAdditionalOfficeBreakdownCols = [
    { col: mdCols.officeId, colDef: colSettings.textMd },
    { col: mdCols.streetName, colDef: colSettings.textLg },
    { col: mdCols.city, colDef: colSettings.textMd },
    { col: mdCols.zipCode, colDef: colSettings.textSm },
];
